import styled from 'styled-components/macro'
import { prop } from 'styled-tools'

const Wrapper = styled.div`
  position: relative;
  width: 125px;
  cursor: pointer;
  background: white;
  border-radius: 5px;
  border-width: 1px;
  padding: 10px;
`

const ImgPreview = styled.div`
  height: ${props => (props.vertical ? '230px' : '130px')};
  border: 1px solid gray;
  cursor: pointer;
  width: 100%;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url('${prop('url', '')}');
  flex:1;
`

const SlideButton = styled.button`
  background-color: white;
  line-height: 0;
  position: absolute;
  top: ${props => (props.vertical ? '120px' : '75px')};
  display: block;
  width: 1.5rem;
  height: 5rem;
  padding: 0;
  -webkit-transform: translate(0, -50%);
  -ms-transform: translate(0, -50%);
  transform: translate(0, -50%);
  cursor: pointer;
  color: black;
  border: none;
  outline: none;
  &:focus {
    outline: 0;
  }
`

const NextSlide = styled(SlideButton)`
  right: 0;
`

const PrevSlide = styled(SlideButton)`
  left: 0;
  z-index: 2;
`

export { Wrapper, ImgPreview, NextSlide, PrevSlide }
